import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import Utils from '../../../custom/utils';
import {API} from "../../../../config";

const moment = require('moment');

const allocs = API.service('ipo-subscription');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        border:'2px solid #6e6e6e',
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    }
});

class InvestorAllocation extends Component {
    state={
        holdings:[]
    };

    getHoldings = () => {
        const app = this;
        allocs.find({query:{_investor_account:this.props.investor._account}}).then(s=>{
            console.log('holdings:',s);
            app.setState({
                holdings:s.data
            })
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.investor._id !== this.props.investor._id) {
            this.getHoldings()
        }
    }

    componentDidMount() {
        this.getHoldings()
    }

    render() {
        const {classes} = this.props;

        return (
            <React.Fragment>
                <table className={'w-full'}>
                    <tr className={classes.tableHead}>
                        <td>Date</td>
                        <td className={'text-center pl-2'}>Symbol</td>
                        <td className={'text-center pl-2'}>Status</td>
                        <td className={'text-center pl-2'}>Quantity</td>
                        <td className={'text-center pl-2'}>Price</td>
                        <td className={'text-center pl-2'}>Fee</td>
                        <td className={'text-center pl-2'}>Value</td>
                    </tr>
                    {this.state.holdings.map((v,i)=>{
                        return (
                            <tr>
                                <td>{(v._timestamp) ? moment(v._timestamp).format('L') : ''}</td>
                                <td>{v.companies[0]._trading_symbol}</td>
                                <td className={'text-center pl-2'}>
                                    {(v._status === 1) ? (<div className='kyc-label approved'>Pending</div>) :''}
                                    {(v._status === 2) ? (<div className='kyc-label allowed'>Allocated</div>) :''}
                                    {(v._status === 3) ? (<div className='kyc-label denied'>Cancelled</div>) :''}
                                </td>
                                <td className={'text-center pl-2'}>{Utils.addThousandCommas(v._amount,'0,0')}</td>
                                <td className={'text-center pl-2'}>{Utils.addThousandCommas(v._share_price,'0,0.00')}</td>
                                <td className={'text-center pl-2'}>{Utils.addThousandCommas(v._fee,'0,0.00')}</td>
                                <td className={'text-center pl-2'}>{Utils.addThousandCommas(v._value, '0,0.00')}</td>
                            </tr>
                        )
                    })}
                </table>
            </React.Fragment>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(InvestorAllocation)));
